export enum CountryIds {
    US = 1,
    CostaRica = 2,
    Canada = 3,
    AmericanSamoa = 4,
    Palau = 5,
    Guam = 6,
    NorthernMarianaIslands = 7,
    USVirginIslands = 8,
    PuertoRico = 9
}
